
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/MindMap/index.md?watch=parent';
    export const demoIndex = {
  ids: ["mindmap-demo-common","mindmap-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__MindMap" */'/home/runner/work/GPT-Vis/GPT-Vis/src/MindMap/index.md?type=demo')
};